import React from 'react';
import UserLogin from '@/components/user/login/UserLogin';
import UserProfileLink from '@/components/user/profile/link/UserProfileLink';
import UserLogout from '@/components/user/logout/UserLogout';
import {useSessionInfoQuery} from '@/api/useSessionInfoQuery';
import {useSessionStore} from '@/state/sessionStore';
import UserRegister from "@/components/user/register/UserRegister";

export type UserSidebarProps = {
  className?: string;
  profileClassName?: string;
  loginClassName?: string;
  logoutClassName?: string;
};

/**
 * Sidebar user section that conditionally renders auth-related actions.
 * - If the visitor is a guest: shows the Login button.
 * - If authenticated: shows Profile link and Logout button.
 */
const UserSidebar: React.FC<UserSidebarProps> = ({
                                                   className,
                                                   profileClassName,
                                                   loginClassName,
                                                   logoutClassName,
                                                 }) => {
  // Keep session store up to date (isGuest, csrf, etc.)
  useSessionInfoQuery();
  const isGuest = useSessionStore((s) => s.isGuest);
  const effectiveIsGuest = isGuest ?? true;

  return (
    <div className={className}>
      {effectiveIsGuest ? (
        <div className="space-y-2">
          <UserLogin className={loginClassName}/>
          <UserRegister className={loginClassName}/>
        </div>
      ) : (
        <div className="space-y-2">
          <UserProfileLink className={profileClassName}/>
          <UserLogout className={logoutClassName}/>
        </div>
      )}
    </div>
  );
};

export default UserSidebar;
